(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("bin-tree-org", [], factory);
	else if(typeof exports === 'object')
		exports["bin-tree-org"] = factory();
	else
		root["bin-tree-org"] = factory();
})(window, function() {
return 